import { render, staticRenderFns } from "./cly-metric-cards.vue?vue&type=template&id=bcbd0c1c"
import script from "./cly-metric-cards.vue?vue&type=script&lang=js"
export * from "./cly-metric-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports